import { Directive, Input, TemplateRef, inject } from '@angular/core';

@Directive({
  selector: '[appCustomCompactListColumn]'
})
export class CustomCompactListColumnDirective {
  @Input('appCustomCompactListColumn') columnName: string;
  public readonly template = inject(TemplateRef<any>); 
}
